// import { OccType, PriceChannel, PriceType, SourceChannelType } from '@/config';
import actionType from '../actions/priceCalendar/actionType';

export interface PriceInitialState {
  businessDate: any;
  datePriceMap: { [key: string]: Partial<any> };
  priceLoading: boolean;
}

const initialState: PriceInitialState = {
  // 营业日
  businessDate: '',
  // 日历价格map
  datePriceMap: {},
  // 打折配置
  priceLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.TOGGLE_PRICE_LOADING: {
      const loading = state[action.payload];
      return {
        ...state,
        [action.payload]: !loading,
      };
    }
    case actionType.UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.PRICE_MAP:
      return {
        ...state,
        ...action.payload,
      };
    case actionType.SET_BUSI_DATE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
